import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import {connect} from 'react-redux';

function SeeTrackOnAdminButton(props) {
    const { adminEditUrl, canManageAlbum, ...childProps } = props;

    if (!canManageAlbum) {
        return null;
    }

    delete childProps.dispatch;

    return (
        <a {...childProps} href={adminEditUrl}>{I18n.t('model.track.actions.show_in_admin')}</a>
    );
}

SeeTrackOnAdminButton.propTypes = {
    adminEditUrl: PropTypes.string,
    canManageAlbum: PropTypes.bool.isRequired,
};

export default connect((state) => ({
    canManageAlbum: state.authentication.permissions.canManageAlbum
}))(SeeTrackOnAdminButton);
